import React from "react";
import { ReportPreviewData, ReportGenerationOptions } from "../types";
import { HoldingWithInstrumentAndAccount, TransactionWithInstrumentAndAccount } from "@/types";
import { ReportPreviewHeader } from "./ReportPreviewHeader";
import { NAVSummarySection } from "./NAVSummarySection";
import { HoldingsDetailSection } from "./HoldingsDetailSection";
// New sections
import { ExceptionSummarySection } from "./sections/ExceptionSummarySection";
import { SignOffSection } from "./sections/SignOffSection";

interface ReportPreviewProps {
  reportData: ReportPreviewData;
  reportOptions: ReportGenerationOptions;
  holdings?: HoldingWithInstrumentAndAccount[];
  transactions?: TransactionWithInstrumentAndAccount[];
}

export const ReportPreview: React.FC<ReportPreviewProps> = ({
  reportData,
  reportOptions,
  holdings = [],
  transactions = [],
}) => {
  return (
    <div className="space-y-6">
      <ReportPreviewHeader 
        reportData={reportData} 
        reportOptions={reportOptions} 
      />

      {reportOptions.includeNAVSummary && (
        <NAVSummarySection holdings={holdings} />
      )}

      {/* Exception Summary below NAV Summary */}
      <ExceptionSummarySection 
        summary={reportData.exceptionSummary}
        details={reportData.exceptionDetails}
      />

      {/* Sign-off above detail sections */}
      <SignOffSection />

      {reportOptions.includeHoldings && (
        <HoldingsDetailSection holdings={holdings} />
      )}
    </div>
  );
}; 